import React, { useContext, useState, useEffect, useRef } from "react"
import Context from "../utils/Context"
import { sendTaskToRobot, cancelActions } from "../utils/ROS/ROSFunctions"
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faPlus, faStopCircle, faCog, faListOl, faCompass, faDolly, faChargingStation, faThList, faMinusCircle, faPlay, faBoxOpen } from '@fortawesome/free-solid-svg-icons'
import ShowMessage from "../components/ShowMessage"
import api from "../api/api"
import ListOrders from "./ListOrders"



export default function Store() {
  const context = useContext(Context)
  const [orders, setOrders] = useState()

  const defaultOrder = { createdBy: context.user && context.user._id, owner: context.user && context.user.owner }
  const [selectedOrder, setSelectedOrder] = useState(defaultOrder)
  const [filters, setFilters] = useState({ dtCompleted: { $exists: false }, cancelled: false })
  const isMounted = useRef(true)
  //const listHeaders = ["mission", "start", "state", "action"]
  const listHeaders = ["missão", "robô", "início", "estado", "ação"]
  const [cancelled, setCancelled] = useState(null)
  const refreshRate = 5000


  const [showWarning, setShowWarning] = useState(false)
  const [showCountdown, setShowCountdown] = useState(false)
  const [countdown, setCountdown] = useState(10)
  const [timer, setTimer] = useState(null)

  // start task
  const startTask = (mission) => {
    if (mission) {
      sendTaskToRobot({ actions: mission.actions, id: mission.name, name: mission.name })
      context.actions.setMessage({ message: "Mission started!", type: "success" })
      console.log('publishing mission: ', { actions: mission.actions, id: mission.name, name: mission.name })
    }
  }

  useEffect(() => {

    if (isMounted.current)
      api
        .fetchOrders(filters)
        .then((res) => {
          res && isMounted.current && setOrders(res.data)
        })
        .catch((e) => console.log(e))
  }, [cancelled])



  useEffect(() => {
    const refresher = setInterval(() => {

      if (isMounted.current)
        api
          .fetchOrders(filters)
          .then((res) => {
            res && isMounted.current && setOrders(res.data)
          })
          .catch((e) => console.log(e))
    }, refreshRate)

    return () => {
      if (refresher) clearInterval(refresher)
    }

  }, [])



  const cancelledSet = cancel => setCancelled(cancel)

  const selectOrder = (orderId) => {
    if (!orderId) {
      setSelectedOrder(defaultOrder)
      return false
    }
    setSelectedOrder(orders.find((order) => order._id === orderId))
  }


  const startDistribution = async () => {
    try {

      await api.startDistributions({
        robotId: context.robotInfo?._id ? context.robotInfo._id : "668569a25067644208b2c3fe",
        robotName: context.robotInfo?.name ? context.robotInfo.name : "1000PT",
        owner: context.robotInfo?.owner ? context.robotInfo.owner : "SONAE",
        createdBy: context.user ? context.user._id : '',
        operationId: context.operation ? context.operation._id : '66857bb15067644208b3827c'
      })

      context.actions.setMessage({ message: "Começar distribuição", type: "sucess" })

    } catch (error) {
      context.actions.setMessage({ message: "Erro a começar", type: "error" })
    }

  }



  // execute a mission
  const execMission = (missionName) => {
    const mission = context.availableMissions.find(m => m.name === missionName)
    const hasUV = mission?.actions?.find(action => action.name === "desinfect-uv" || action.name === "desinfect-all")

    if (mission) {
      // console.log("found mission", mission)

      context.actions.setCurrentMission({ ...mission, hasUV: hasUV ? true : false })
    }

    if (hasUV) {
      setShowWarning(true)
    } else {
      startTask(mission)
    }
  }

  const startCharger = () => {

    var string = {
      "robot": "1500PT",
      "mapIndex": 0,
      "name": "Charger",
      "actions": [
        {
          "id": "go-to",
          "name": "go-to",
          "needsValue": true,
          "value": "Charger"
        },
        {
          "id": "dock",
          "name": "dock",
          "needsValue": true,
          "value": "charger"

        },
        {
          "id": "orientate-to",
          "name": "orientate-to",
          "needsValue": true,
          "value": "A_Charger"
        }
      ]
    }

    startTask(string)

  }

  const releaseCharge = () => {

    var string = {
      "robot": "1500PT",
      "mapIndex": 0,
      "name": "ReleaseCharger",
      "actions": [
        {
          "id": "orientate-to-fork",
          "name": "orientate-to-fork",
          "needsValue": true,
          "value": "A_Portao_Armazem"
        },
        {
          "id": "release-charger",
          "name": "release-charger",
          "needsValue": true,
          "value": ""

        },
        {
          "id": "go-to",
          "name": "go-to",
          "needsValue": true,
          "value": "A_Portao_Armazem"
        },
        {
          "id": "fork",
          "name": "fork",
          "needsValue": true,
          "value": "0.1"
        }
      ]
    }

    startTask(string)
  }

  const frente = async () => {

    var string = {
      "robot": "1500PT",
      "mapIndex": 0,
      "name": "fork",
      "actions": [
        {
          "id": "fork",
          "name": "fork",
          "needsValue": true,
          "value": "0.1"
        }
      ]
    }

    startTask(string)

  }

  const stopMission = async () => {
    if (context.isRobotConnected) {
      if (context.selectedRobot.ROS === 'ROS2') {
        cancelActions({ stopall: true }, context.selectedRobot.ROS)
      } else {
        cancelActions({ stopAll: true }, context.selectedRobot.ROS)
      }
    }

    context.actions.setCurrentMission(null)
    try {
      await api.cancelAllOrders()

      api.sendTrigger({ device: 'Stop-Missions', processed: false, uname: context.user.name, dtInsert: new Date() })
    } catch (error) {
      context.actions.setMessage({ message: "Erro a começar no servidor", type: "error" })
    }

    context.actions.setMessage({ message: "Missão parada!", type: "success" })

  }

  const execLocation = () => {

    sendTaskToRobot({ actions: [{ value: "Base", name: "publish-pose" }], id: "Base", name: "PRIORITY" })
    context.actions.setMessage({ message: "Ok!", type: "success" })

  }

  // start countdown
  const startCountdown = () => {
    setShowCountdown(true)

    setTimer(
      setInterval(() => {
        setCountdown(c => c - 1)
      }, 1000)
    )
  }

  // end of countdown
  useEffect(() => {
    if (countdown === 0) {
      clearInterval(timer)
      setTimer(null)
      setShowCountdown(false)
      setCountdown(10)
      startTask(context.currentMission)
      setShowWarning(false)
    }
  }, [countdown, context.currentMission, timer])

  return (
    <div>
      {context.settings.fmsConnection &&
        <>
          <button
            onClick={() => context.actions.setModalState({ ...context.modalState, distribution: true })}
            className="button is-info mb-5 mr-3"
            styles={{ marginRight: "1rem" }}
          >
            <FontAwesomeIcon icon={faListOl} className="is-small mr-1" />
            Manage Distributions
          </button>

          <button
            onClick={() => context.actions.setModalState({ ...context.modalState, collect: true })}
            className="button is-info mb-5 mr-3"
            styles={{ marginRight: "1rem" }}
          >
            <FontAwesomeIcon icon={faListOl} className="is-small mr-1" />
            Manage Collect
          </button>
        </>
      }

      {context.isRobotConnected &&
        <button
          onClick={() => context.actions.setModalState({ ...context.modalState, missions: true })}
          className="button is-success mb-5 mr-3"
          styles={{ marginRight: "1rem" }}
        >
          <FontAwesomeIcon icon={faPlus} className="is-small mr-7" />
          Manage Missions
        </button>
      }

      <button className="button is-outlined is-link mr-2 mb-2" onClick={() => startDistribution()}>
        <FontAwesomeIcon icon={faPlay} className="is-small mr-1" />
        Start Distribution
      </button>

      {context.isRobotConnected &&
        <>
          <button className="button is-outlined is-link mr-2 mb-2" onClick={() => startCharger()}>
            <FontAwesomeIcon icon={faChargingStation} className="is-small mr-1" />
            Charge
          </button>
          <button className="button is-outlined is-link mr-2 mb-2" onClick={() => releaseCharge()}>
            <FontAwesomeIcon icon={faMinusCircle} className="is-small mr-1" />
            Release Charger
          </button>
          <button className="button is-success is-link mr-2 mb-2" onClick={() => execLocation()}>
            <FontAwesomeIcon icon={faCompass} className="is-small mr-1" />
            Locate
          </button>
          <button className="button is-outlined is-link mr-2 mb-2" onClick={() => frente()}>
            <FontAwesomeIcon icon={faDolly} className="is-small mr-1" />
            Lower fork
          </button>
        </>
      }
      <button
        onClick={stopMission}
        className="button is-danger mb-5 mr-3"
      >
        <FontAwesomeIcon icon={faStopCircle} className="is-small mr-1" />
        Cancel All
      </button>

      <br />

      {context.availableMissions.length > 0 && context.isRobotConnected &&
        context.availableMissions.map((mission, i) => {
          if (mission.robot === context.selectedRobot?.name) {
            return <button key={i} className="button is-outlined is-link mr-2 mb-5" onClick={() => execMission(mission.name)}>
              {mission.name + " "}
            </button>
          }
        })}


      {orders &&
        <div className="box" style={{ "borderRadius": "15px", "textAlign": "center" }}>
          <div className="column is-12">
            <ListOrders data={orders} handler={selectOrder} headers={listHeaders} cancelled={cancelledSet} cancelledValue={cancelled} />
          </div>
        </div>
      }

      <ShowMessage />

    </div>
  )
}
